import { render, staticRenderFns } from "./Domains.vue?vue&type=template&id=4b1e15f1&"
import script from "../domains.js?vue&type=script&lang=js&"
export * from "../domains.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports